module.exports = __webpack_public_path__ + "static/img/lres8.58e41a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/lres8.png
// module id = IHRU
// module chunks = 1